/* eslint-disable react/prop-types */
import { colors, strCode } from "../../../consts";

import { Checkbox, TextOverflowWrapper, WrapperContainer } from "../../../components";
import { CellWrapper } from "../../../components/Table/styled";

export const MarketsTabModalTableColumns = [
  {
    Header: strCode.MARKET_NAME,
    accessor: "name",
    Cell: ({
      cell,
      searchedText,
      callbackFn1: onMarketSelecting,
      callbackFn2: isMarketSelected
    }) => {
      const isChecked = isMarketSelected(cell.row.original.id);

      return (
        <CellWrapper width="100%">
          <WrapperContainer mr={16}>
            <Checkbox
              checked={isChecked}
              onCheck={(e) => {
                e.stopPropagation();
                onMarketSelecting(cell.row.original);
              }}
            />
          </WrapperContainer>

          <TextOverflowWrapper
            highlightedText={searchedText}
            style={{
              color: colors.RAISIN_70
            }}>
            {cell.value}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  }
];
